"use strict"

window.app = window.app || {}

window.app = (function(app) {

    app.initCallbacks = []
    app.addInitCallback = function(fn) {
        app.initCallbacks.push(fn)
    }

    app.init = () => {
        app.initCallbacks.forEach(cb => cb(app))

        document.querySelector(".page .page__content .menu-link").addEventListener("click", function(e) {
            e.preventDefault()

            let page_content_el = document.querySelector(".page .page__content")
            const MENU_OPEN = "page__content--menu-open"

            page_content_el.classList.contains(MENU_OPEN) ?
                page_content_el.classList.remove(MENU_OPEN) :
                page_content_el.classList.add(MENU_OPEN)
        });

        function trans(key, insert, insert2) {
            if (Lg === undefined) {
                return key;
            }
            return translate(key, insert, insert2); // využití načtení skriptu /admin/modules/system/javascript/presentation.js
        }

        function init_light_box() {

            $('img[data-expandable="1"]').each(function() {
                var a = $('<a>');
                a.attr('href', $(this).attr('src'));
                if ($(this).attr('title')) {
                    a.attr('title', $(this).attr('title'));
                } else {
                    a.attr('title', $(this).attr('alt'));
                }
                a.attr('data-rel', 'imagebox-intext');
                var b = $(this).clone();
                a.html(b);
                $(this).replaceWith(a);
            });

            /* fotogalerie */
            $("a[data-rel^='imagebox'],a[data-rel^='lightbox'],a[data-rel^='prettyphoto'],a[rel^='imagebox'],a[rel^='lightbox'],a[rel^='prettyphoto']").magnificPopup({
                type:'image',
                midClick: true,
                closeOnBgClick: true,
                closeBtnInside: true,
                overflowY: 'auto',
                gallery: {
                    enabled: true,
                    tCounter: '%curr% / %total%'
                }
            });

        }

        function ajax_after_calls() {
            init_light_box();
        }

        $(document).ready(function(){

            init_light_box();

            $(document.body).on("click", "a.ajax", function (event) {
                event.preventDefault();
                $.get(this.href);
                $(".ajax-spinner").show();
            });

            $(document.body).on('submit', 'form.ajax', function() {
                $(this).ajaxSubmit();
                return false;
            });

            // odeslání formuláře webtextu ajaxem - formuláři je potřeba nastavit třídu wtajax
            $('form.wtxajax').on('submit', function () {
                var $that = $(this);
                if ($that.data('htmlid') !== undefined) { // z formuláře vyrušit onsubmit a doplnit data-htmlid
                    if (!webx_validate_form($that.data('htmlid'))) {
                        return false;
                    }
                }
                $that.prevAll('.report').remove(); // odstranit předchozích reportů
                $(this).ajaxSubmit(function(payload){
                    jQuery(".ajax-spinner").hide();

                    if (payload.report) {

                        // přidání reportu
                        var $rep = $('<p>');
                        $rep.addClass('report');
                        $rep.addClass(payload.report.type);
                        $rep.html(payload.report.txt);
                        $that.before($rep);

                        if (payload.report.clean_form) { // vyprázdnit formulář
                            $('input[type=text],input[type=password],textarea', $that).val('');
                            $('input[type=checkbox]', $that).prop('checked', false);
                        }
                        if (payload.report.remove_form) { // odstraň formulář
                            $that.remove();
                        }

                    }

                });
                return false;
            });

            // zavírání/otvírání bloků
            $('.titlebox.open>.titlebox-content').slideDown();
            $('.titlebox>h2.titlebox-title').click(function(ev){
                var $parent = $(this).parent();
                var was_opened = $parent.hasClass('open');
                $('.titlebox.open').each(function(){
                    var $el = $(this);
                    $('.titlebox-content', $el).slideUp();
                    $el.removeClass('open');
                });
                if (!was_opened) {
                    $parent.addClass('open');
                    $('.titlebox-content', $parent).slideDown();
                }
                ev.preventDefault();
                return false;
            });

            /* stylování selectů */
            $('select:not([multiple])').customSelect({default_height: '33'});

        });

    }

    return app
})(window.app)